module.exports = __webpack_public_path__ + "static/media/09_avatar_male.baea3ab1.png";